'use strict';

var scrollAnimate = require('./scrollAnimate');

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked for email sign-up
 */
function displayMessage(data, button) {
    $.spinner().stop();
    var status;
    if (data.success) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }

    if ($('.email-signup-message').length === 0) {
        $('body').append(
           '<div class="email-signup-message"></div>'
        );
    }
    $('.email-signup-message')
        .append('<div class="email-signup-alert text-center ' + status + '">' + data.msg + '</div>');

    setTimeout(function () {
        $('.email-signup-message').remove();
        button.removeAttr('disabled');
    }, 3000);
}

module.exports = function () {
    $('.back-to-top').click(function () {
        scrollAnimate();
    });

    $('.subscribe-email').on('click', function (e) {
        e.preventDefault();
        var url = $(this).data('href');
        var button = $(this);
        var emailId = $('input[name=hpEmailSignUp]').val();
        $.spinner().start();
        $(this).attr('disabled', true);
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: {
                emailId: emailId
            },
            success: function (data) {
                displayMessage(data, button);
            },
            error: function (err) {
                displayMessage(err, button);
            }
        });
    });
};

const mobileAccordions = document.querySelectorAll('.mobile-accordion .is-accordion h6');
mobileAccordions.forEach(m => {
    m.addEventListener('click', function(){
        this.classList.toggle('is-active');
    });
});

$('.country-selector #dropdownCountrySelector').on('click', function(){
    if($('.dropdown.country-selector').hasClass('show')) {
        $('.dropdown.country-selector').removeClass('show');
        $('.dropdown-menu.dropdown-country-selector').removeClass('show');
    } else {
        $('.dropdown.country-selector').addClass('show');
        $('.dropdown-menu.dropdown-country-selector').addClass('show');
    }
});

var btn = $('#to-top-button');

$(window).scroll(function() {
  if ($(window).scrollTop() > 300) {
    btn.addClass('show');
  } else {
    btn.removeClass('show');
  }
});

btn.on('click', function(e) {
  e.preventDefault();
  $('html, body').animate({scrollTop:0}, '300');
});

$('.cc-tile > .cc-accordion-item > .cc-accordion-button, .experience-commerce_assets-accordion > .cc-accordion-item > .cc-accordion-button').each(function(index) {
    $(this).attr('data-target', '#collapse-' + index);
});

$('.cc-tile > .cc-accordion-item > .cc-accordion-body, .experience-commerce_assets-accordion > .cc-accordion-item > .cc-accordion-body').each(function(index) {
    $(this).attr('id', 'collapse-' + index);
});


// WEBPACK FOOTER //
// ./cartridges/app_fh/cartridge/client/default/js/components/footer.js